import styled from 'styled-components';

export const ThemeBtn = styled.div`
  font-size: 1.6rem;
  background: transparent;
  color: ${(p) => p.theme.accent.secondary};
  transform: ${(p) => (p.isDarkMode ? 'rotate(0deg)' : 'rotate(30deg)')};
  transition: 0.4s transform ease-in-out, 0.2s background ease-in-out;
  border-radius: 20rem;
  padding: 0.5rem;
  cursor: pointer;

  &:hover {
    background: ${(p) => p.theme.accent.primary}20;
  }

  &:active {
    background: ${(p) => p.theme.accent.primary}50;
  }

  @media screen and (max-width: 767px) {
    font-size: 1.6rem;
    padding: 0.7rem;
    background: ${(p) => p.theme.accent.primary};
    color: ${(p) => p.theme.background};
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
      0 2px 4px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.12),
      0 2px 16px rgba(0, 0, 0, 0.12);

    &:hover {
      background: ${(p) => p.theme.accent.secondary};
    }

    &:active {
      background: ${(p) => p.theme.accent.primary}90;
    }
  }
`;
